/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import clsx from 'clsx';
import customStyles from "../../../../../assets/styles/customStyles";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { ListTable } from './ListTable.js';
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import { Row, Col, Image, Space } from "antd";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { Button, TextField, Box, FormControlLabel, Switch } from "@mui/material";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import MainHeader from "../../../../Shared/components/Header";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import usePrevious from "../../../../Shared/components/Previous";
import actions from "../../redux/actions";
import { customAlaphabetValidation, emptyValidation } from "../../../../../helpers/validation";
import { toast } from 'react-toastify';
import crudActions from "../../../../CRUD/redux/actions";
import { CustomSelect } from "../../../../Shared/components/CustomSelect";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { checkViewPermission, checkCRUDPermission, checkComponentPermission } from '../../../../../helpers/utilities';

const MethodOfPayment = (props) => {
    const { walletDetails, mopDetails, loader } = useSelector(state => state.adminSetupReducer);
    const { createDetails, createError, createLoader, getList, getData } = useSelector(state => state.crudReducer);
    const [visible, setVisible] = useState(false);
    const [name, setName] = useState('');
    const [walletId, setWalletId] = useState('');
    const [addMore, setAddMore] = useState(false);
    const [errorName, setErrorName] = useState(false);
    const [errorWalletId, setErrorWalletId] = useState(false);
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const [description, setDescription] = useState('');
    const [isPaymentService, setIsPaymentService] = useState(false);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);

    const [importVisible, setImportVisible] = useState(false);


    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [skip, setSkip] = useState(0);
    const limit = 25;

    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);

    const { roleManagement } = useSelector(state => state.authReducer);
    const { history } = props;

    const classes = customStyles();
    const handleOpen = () => {
        setVisible(true);
        emptyState();
        emptyStateInput();
    };

    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();
    }

    const dispatch = useDispatch();

    useEffect(() => {
        if ((prevSearch !== undefined && search && search?.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Method of Payment', history, 'Younote Admin')) {
                loadTasks();
            }
        }
    }, [roleManagement]);

    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData?.length > 0) {
                    setLoadMore(true);
                    if (getData?.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ method: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } });
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'mop',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const loadTasks = useCallback(() => {
        dispatch({
            type: actions.WALLET_DETAILS_START, url: 'wallet', filter: {
                order: 'id desc',
            }
        });
        dispatchFilter(sortBy, sortOrder);
    });

    const emptyState = () => {
        setErrorName(false);
        setErrorWalletId(false);
    };

    const emptyStateInput = () => {
        setName('');
        setDescription('');
        setWalletId('');
        setIsPaymentService(false);
    };

    const createMop = (e) => {
        e.preventDefault();
        let wallet = true;
        let emptyName = customAlaphabetValidation('Name', name);
        let emptywallet = emptyValidation('Digital Wallet', walletId, 'dropDown');
        if (isPaymentService && !emptywallet.isValid) {
            wallet = false
        }
        emptyState();
        if (emptyName.isValid && wallet) {
            let details = {
                method: name,
                description: description,
                isPaymentService: isPaymentService,
            };
            if (walletId) {
                details["walletId"] = walletId;
            }
            dispatch({
                type: crudActions.CREATE_DETAILS_START,
                url: 'mop',
                title: 'Method of payment',
                details: details
            })
        }
        else {
            if (emptyName.errors) {
                setErrorName(emptyName.errors);
            }
            if (wallet === false && emptywallet.errors) {
                setErrorWalletId(emptywallet.errors);
            }
        }
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            dispatchFilter(sortBy, sortOrder);
            setVisible(false);
            toast.dismiss();
            toast(createDetails);
            emptyStateInput();
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message.split("|");
            setErrorName(error);
        }
    }, [createDetails, createError, prevCreateDetails, prevCreateError]);

    const handleAddMore = (e) => {
        createMop(e);
        setAddMore(true);
    }

    const paymentService = (value) => {
        setIsPaymentService(!value);
        setWalletId('');
    }


    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.MOP_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'mop',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg} title={'Admin'} links={[{ 'label': 'Admin', 'link': '/admin' }, { 'label': 'Method Of Payment', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Method of Payment'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Method of Payment', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                className={classes.comInput}
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.allCustomerTop)}>
                                    <div className={classes.overlFlowResponsiveDesign}>
                                        <Space size={[20, 20]} direction="horizontal" align="center" >

                                            {
                                                roleManagement !== '' && checkComponentPermission('Method of Payment', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { loadImportExportData('Method of payment'); }}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Method of Payment', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { setImportVisible(true); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Method of Payment', 'create', 'Younote Admin') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => handleOpen()}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Method Of Payment</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Method of Payment', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <ListTable
                                loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                walletDetails={walletDetails}
                                sortOrder={sortOrder} sortBy={sortBy}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
                <PrimaryDrawer
                    anchor={'right'}
                    open={visible}
                    variant={'temporary'}
                    handleClose={() => handleClose()}
                    title={'Add Method Of Payment'}
                    className={classes.closeBackGround}
                    component={
                        <Box
                            className={clsx(classes.customForm, classes.removeUnderline)}
                            component='form'
                            autoComplete='off'
                            onSubmit={(e) => createMop(e)}
                        >
                            <div className={classes.customFormFlex}>
                                <TextField autoComplete='one-time-code'
                                    label={["Method Of Payment ", <span key={"Method Of Payment"} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    error={errorName ? true : false}
                                    helperText={errorName}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setName(e.target.value)}
                                />
                                <TextField autoComplete='one-time-code'
                                    label='Description'
                                    variant={'standard'}
                                    className={clsx(classes.margin30t)}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                                <div className={classes.textAlignLeft}>
                                    <FormControlLabel
                                        classes={{
                                            label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                        }}
                                        control={<Switch size='small' className={clsx(classes.customSwitch, classes.marginLeft10)}
                                            onChange={(e) => { paymentService(isPaymentService) }}
                                        />}
                                        label="Use Payment Services"
                                        labelPlacement="start"
                                        checked={isPaymentService}
                                        className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                    />
                                </div>
                                <div className={clsx(classes.margin30t, { [classes.disabled]: !isPaymentService })}>
                                    <CustomSelect
                                        parentClasses={clsx(classes.labelWidth50)}
                                        lableClasses={clsx(classes.textFieldLableColorCustom)}
                                        customClasses={clsx(classes.dropDownHighlight, classes.dropDownPointer)}
                                        details={walletDetails}
                                        name="Digital Wallet"
                                        onChange={(e) => setWalletId(e.target.value)}
                                        defaultValue={walletId}
                                        error={errorWalletId}
                                        heads={['id', 'name']}
                                    />

                                    <NavLink to={'#'}>
                                        <Image
                                            src={DeleteIcon}
                                            onClick={() => paymentService(true)}
                                            preview={false}
                                            className={clsx(classes.switchDeleteButton)}
                                        />
                                    </NavLink>
                                </div>
                            </div>
                            <div className={clsx(classes.btnParent)}>
                                <Space direction="horizontal" align="center" size={[10, 10]}>
                                    <Button
                                        key="save"
                                        type='submit'
                                        color='primary'
                                        variant="contained"
                                        className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}
                                    >
                                        Save & Close
                                    </Button><Button
                                        key="add"
                                        type='submit'
                                        color='primary'
                                        variant="contained"
                                        className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                        onClick={(e) => handleAddMore(e)}
                                    >
                                        Add More
                                    </Button>
                                </Space>
                            </div>
                        </Box>
                    }
                />
            </div>
            <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'Method of payment'}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={mopDetails}
                loadTasks={() => { dispatchFilter(sortBy, sortOrder) }}
            />
        </React.Fragment >
    )
}
export default MethodOfPayment